import { QuickPassVerificationStatus } from '../../_types/quickpass-verification'
import { StatusDisplay } from './types'

const STATUS_DISPLAY: Record<QuickPassVerificationStatus, StatusDisplay> = {
  unverified: { label: 'Not verified', tone: 'neutral' },
  pending: { label: 'In progress', tone: 'pending' },
  processing: { label: 'Processing', tone: 'pending' },
  verified: { label: 'Verified', tone: 'verified' },
  failed: { label: 'Could not verify', tone: 'failed' },
  expired: { label: 'Expired', tone: 'failed' },
}

/**
 * The query parameter Didit's hosted flow returns the renter with.
 *
 * Didit runs off site, so this marker is the only way the profile page can tell
 * a renter who just finished an attempt from one who simply navigated here. The
 * server return URL must end in `?<this>=1` or a completed verification will sit
 * unsynced until the webhook lands.
 */
const IDENTITY_RETURN_PARAMETER = 'identity-return'

/**
 * Maps a verification status to its display label + tone.
 *
 * @param {QuickPassVerificationStatus} status
 * @returns {StatusDisplay}
 */
const resolveStatusDisplay = (
  status: QuickPassVerificationStatus,
): StatusDisplay => {
  return STATUS_DISPLAY[status] ?? STATUS_DISPLAY.unverified
}

export { IDENTITY_RETURN_PARAMETER, resolveStatusDisplay }
